import { LookupFields, UserFields } from "src/modules/modules.type";
import { FIELDS_TYPES } from "./type.config";
import { Moment } from "moment";
import { LookUpRecord, UserRecord } from "src/types/main";

export const myTasksAuditListName = "MyTasksAudit";
export const myTasksAuditWithRelationsListName = "MyTasksAuditRelations";
export const myTasksAuditQuestionsListName = "MyTasksAuditQuestions";
export const myTasksAuditFilesListName = "MyTasksAuditFiles";

export const MyTaskAuditNameFields = {
  [myTasksAuditWithRelationsListName]: {
    MOldId: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    DateOb: FIELDS_TYPES.DATE,
    Observer: FIELDS_TYPES.USER,
    ObserverEmail: FIELDS_TYPES.STRING,
    ObservedType: FIELDS_TYPES.CHOICE,
    ObservedUser: FIELDS_TYPES.USER,
    ObservedUserEmail: FIELDS_TYPES.STRING,
    ObservedString: FIELDS_TYPES.STRING,
    Location: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Region: FIELDS_TYPES.LOOKUP,
    Audit: FIELDS_TYPES.MULTI_STRING_AND,
    Description: FIELDS_TYPES.STRING,
    Feedback: FIELDS_TYPES.STRING,
    AuthorEmail: FIELDS_TYPES.STRING,
    Hide: FIELDS_TYPES.BOOLEAN,
  },
  [myTasksAuditListName]: {
    MOldId: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    DateOb: FIELDS_TYPES.DATE,
    Observer: FIELDS_TYPES.USER,
    ObserverEmail: FIELDS_TYPES.STRING,
    ObservedType: FIELDS_TYPES.CHOICE,
    ObservedUser: FIELDS_TYPES.USER,
    ObservedUserEmail: FIELDS_TYPES.STRING,
    ObservedString: FIELDS_TYPES.STRING,
    Location: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Region: FIELDS_TYPES.LOOKUP,
    Audit: FIELDS_TYPES.MULTI_STRING_AND,
    Description: FIELDS_TYPES.STRING,
    Feedback: FIELDS_TYPES.STRING,
    AuthorEmail: FIELDS_TYPES.STRING,
    Hide: FIELDS_TYPES.BOOLEAN,
  },
  [myTasksAuditQuestionsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    dc0t: FIELDS_TYPES.STRING,
    TypeQuestion: FIELDS_TYPES.CHOICE,
    Options: FIELDS_TYPES.STRING,
    Require: FIELDS_TYPES.BOOLEAN,
    DefaultHide: FIELDS_TYPES.BOOLEAN,
    SortColumn: FIELDS_TYPES.NUMBER,
    Notice: FIELDS_TYPES.STRING,
    Condition: FIELDS_TYPES.STRING,
  },
  [myTasksAuditFilesListName]: {
    ID: FIELDS_TYPES.ID,
    Audit: FIELDS_TYPES.LOOKUP,
    FileRef: FIELDS_TYPES.STRING,
    FileLeafRef: FIELDS_TYPES.STRING,
    UniqueId: FIELDS_TYPES.STRING,
    Name: FIELDS_TYPES.STRING,
    ForHistory: FIELDS_TYPES.BOOLEAN,
  },
};

export type MyTaskAuditFieldsRecordType = {
  [myTasksAuditWithRelationsListName]: {
    MOldId: string;
    ID: number;
    Title: string;
    DateOb: Date;
    Observer: UserFields;
    ObserverEmail: string;
    ObservedType: string;
    ObservedUser: UserFields;
    ObservedUserEmail: string;
    ObservedString: string;
    Location: LookupFields;
    Department: LookupFields;
    Region: LookupFields;
    Audit: string;
    Description: string;
    Feedback: string;
    AuthorEmail: string;
    Hide: boolean;
  };
  [myTasksAuditListName]: {
    MOldId: string;
    ID: number;
    Title: string;
    DateOb: Date;
    Observer: UserFields;
    ObserverEmail: string;
    ObservedType: string;
    ObservedUser: UserFields;
    ObservedUserEmail: string;
    ObservedString: string;
    Location: LookupFields;
    Department: LookupFields;
    Region: LookupFields;
    Audit: string;
    Description: string;
    Feedback: string;
    AuthorEmail: string;
    Hide: boolean;
  };
  [myTasksAuditQuestionsListName]: {
    ID: number;
    Title: string;
    dc0t: string;
    TypeQuestion: string;
    Options: string;
    Require: boolean;
    DefaultHide: boolean;
    SortColumn: number;
    Notice: string;
    Condition: string;
  };
  [myTasksAuditFilesListName]: {
    ID: number;
    Audit: LookupFields;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    ForHistory: boolean;
  };
};

export type MyTaskAuditFieldsType = {
  [myTasksAuditWithRelationsListName]: {
    MOldId: string;
    ID: number;
    Title: string;
    DateOb: Moment;
    Observer: UserRecord;
    ObserverString: UserRecord;
    ObservedType: string;
    ObservedUser: UserRecord;
    ObservedUserEmail: string;
    ObservedString: string;
    Location: LookUpRecord;
    Department: LookUpRecord;
    Region: LookUpRecord;
    Audit: string;
    Description: string;
    Feedback: string;
    AuthorEmail: string;
    Hide: boolean;
  };
  [myTasksAuditListName]: {
    MOldId: string;
    ID: number;
    Title: string;
    DateOb: Moment;
    Observer: UserRecord;
    ObserverString: UserRecord;
    ObservedType: string;
    ObservedUser: UserRecord;
    ObservedUserEmail: string;
    ObservedString: string;
    Location: LookUpRecord;
    Department: LookUpRecord;
    Region: LookUpRecord;
    Audit: string;
    Description: string;
    Feedback: string;
    AuthorEmail: string;
    Hide: boolean;
  };
  [myTasksAuditQuestionsListName]: {
    ID: number;
    Title: string;
    dc0t: string;
    TypeQuestion: string;
    Options: string;
    Require: boolean;
    DefaultHide: boolean;
    SortColumn: number;
    Notice: string;
    Condition: string;
  };
  [myTasksAuditFilesListName]: {
    ID: number;
    Audit: LookUpRecord;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    ForHistory: boolean;
  };
};
